import { CALENDAR_INTERVAL } from './date';

// Reputation Manager rating buckets: star grades as strings, plus Facebook's recommendation grades
export const RM_RATING_BUCKET = {
  RECOMMENDED: 'recommended',
  NOT_RECOMMENDED: 'not_recommended',
  FIVE: '5',
  FOUR: '4',
  THREE: '3',
  TWO: '2',
  ONE: '1'
} as const;

// Calendar periods the Reputation Manager directory breakdown is bucketed by: the shared chart intervals
export const RM_BREAKDOWN_INTERVAL = CALENDAR_INTERVAL;

// How the Reputation Manager directory breakdown counts a period: running total or new in that period
export const RM_BREAKDOWN_TYPE = {
  ALL: 'all',
  NEW: 'new'
} as const;

// When a Reputation Manager report sends email alerts
export const RM_EMAIL_ALERT_MODE = {
  NO_ALERTS: 'no_alerts',
  ALWAYS: 'always',
  ON_NEW_REVIEWS: 'on_new_reviews'
} as const;

// How far a Reputation Manager profile lookup has got; it always ends as completed or failed
export const RM_PROFILE_LOOKUP_STATUS = {
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed'
} as const;

// Workflow status of a Reputation Manager review in the review inbox
export const RM_REVIEW_STATUS = {
  UNREAD: 'unread',
  ACTION_REQUIRED: 'action_required',
  DO_NOT_RESPOND: 'do_not_respond',
  MANUALLY_RESPONDED: 'manually_responded',
  AUTO_RESPONDED: 'auto_responded',
  PENDING_REMOVAL: 'pending_removal',
  SUCCESSFULLY_REMOVED: 'successfully_removed',
  REMOVAL_FAILED: 'removal_failed'
} as const;

// Kind of a Reputation Manager review: a star rating, or a recommend / don't recommend verdict
export const RM_REVIEW_TYPE = {
  REVIEW: 'review',
  RECOMMENDATION: 'recommendation'
} as const;

// Grade of a Reputation Manager review whose type is `recommendation`
export const RM_REVIEW_GRADE = {
  RECOMMENDED: 'recommended',
  NOT_RECOMMENDED: 'not_recommended'
} as const;

// Rating values Find Reviews filters by: star ratings as integers, recommendation grades, or no rating at all
export const RM_REVIEW_RATING_FILTER = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  RECOMMENDED: 'recommended',
  NOT_RECOMMENDED: 'not_recommended',
  NO_RATING: 'no_rating'
} as const;

// A Reputation Manager star rating, as the integer 1 to 5
export const RM_STAR_RATING = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5
} as const;

// Which reviews a Reputation Manager reply template is offered for. The star ratings 1–5 are thresholds:
// `3` means three stars and above, not exactly three
export const RM_TEMPLATE_RATING_TYPE = {
  ALL_RATINGS: 'all_ratings',
  STAR_1: 1,
  STAR_2: 2,
  STAR_3: 3,
  STAR_4: 4,
  STAR_5: 5,
  RECOMMENDED: 'recommended',
  NOT_RECOMMENDED: 'not_recommended'
} as const;

// Minutes an auto-reply rule waits after a review is collected: one hour, eight hours, one day or two days
export const RM_AUTO_REPLY_DELAY = {
  ONE_HOUR: 60,
  EIGHT_HOURS: 480,
  ONE_DAY: 1440,
  TWO_DAYS: 2880
} as const;

// Whether an auto-reply rule replies to reviews with text, without text, or both
export const RM_AUTO_REPLY_REVIEW_RESTRICTION = {
  WITH_TEXT: 'with_text',
  WITHOUT_TEXT: 'without_text'
} as const;
